import { render, staticRenderFns } from "./TopBarNotifications.vue?vue&type=template&id=064467c6&scoped=true"
import script from "./TopBarNotifications.vue?vue&type=script&lang=js"
export * from "./TopBarNotifications.vue?vue&type=script&lang=js"
import style0 from "./TopBarNotifications.vue?vue&type=style&index=0&id=064467c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064467c6",
  null
  
)

export default component.exports